import React, { ReactElement } from 'react';
import Separator from '../components/separator';
import DownloadView from './download';
import UploadView from './upload';
import ToolsSection from './tools-section';
import ModelInput from '../components/inputs/model-input';

function RightPanel(): ReactElement {
  // const config = PW.config.leftPanel;
  const title = PW.config.profilePanel.label;
  const inputs = PW.config.profilePanel.inputs;

  return (
    <div className="right-panel">
      <ToolsSection title={title}>
        {inputs.map((config) => {
          const key = typeof config === 'string' ? config : config.name;
          return (
            <div key={key} className="inputs-list__item">
              <ModelInput config={config} />
            </div>
          );
        })}
      </ToolsSection>
      <Separator />
      <DownloadView />
      <Separator />
      <UploadView />
      <Separator />
    </div>
  );
}

export default RightPanel;
